<div class="app-menu w-[300px]">
  @for (menuItem of appMenu; track menuItem) {
    <a
      data-e2e="AppMenuElements"
      class="menu-item flex h-[68px] w-full cursor-pointer px-[15px]"
      target="_blank"
      rel="noopener noreferrer"
      [attr.href]="menuItem.link"
      (click)="routerLinkActivated.emit()"
    >
      <div class="flex h-full w-full items-center">
        <ux-icon [name]="menuItem.icon" class="text-4xl"></ux-icon>
        <span class="text-base font-semibold">{{ menuItem.label | translate }}</span>
      </div>
    </a>
  }
</div>
